<i18n>
{
  "ru":{
    "do_refund": "Вернуть",
    "on_card": "На карту/счет",
    "full": "Полный",
    "partial": "Частичный"
  },
  "en":{
    "do_refund": "Refund",
    "on_card": "Card/invoice",
    "full": "Full",
    "partial": "Partial"
  }
}
</i18n>
<template>
  <el-dialog
    :close-on-click-modal="false"
    custom-class="webpay refund"
    :visible.sync="visibleInner"
    top="1vh"
    append-to-body
  >
    <section v-loading="loading">
      <el-row :gutter="10" class="pa-3">
        <el-col :md="8" :sm="12">
          <span class="modal_refand_item_title">{{ $t("on_card") }}:</span>
          <span class="modal_refand_item_subtitle">{{
            payment.CARD ? payment.CARD : payment.invoice_transaction_invoice_id
          }}</span>
        </el-col>
        <el-col class="aligner" :md="8" :sm="12">
          <span
            class="card_brand"
            :class="{
              visa: payment.btype == 'VISA',
              mastercard:
                payment.btype == 'MASTERCARD' || payment.btype == 'MC',
              belcard: payment.btype == 'БЕЛКАРТ',
              belqi: payment.btype == 'BELQI WALLET'
            }"
          ></span>
        </el-col>
        <el-col :md="8" :sm="12">
          <span class="modal_refand_item_title"
            >{{ $t("processing_gateway") }}:</span
          >
          <span
            v-if="payment.billing_processing_gateway"
            class="modal_refand_item_subtitle"
            >{{
              $t("processing_gateway_" + payment.billing_processing_gateway)
            }}</span
          >
          <span
            class="modal_refand_item_subtitle"
            v-if="!payment.billing_processing_gateway"
            >-</span
          >
        </el-col>
      </el-row>

      <el-row :gutter="10" class="pa-3">
        <el-col :span="12" class="radio-block">
          <div>
            <el-radio v-model="radio" size="medium" label="1">{{
              $t("full")
            }}</el-radio>
          </div>
          <div>
            <el-radio v-model="radio" size="medium" label="2">{{
              $t("partial")
            }}</el-radio>
          </div>
          <div class="input_total_sum">
            <el-input
              type="number"
              min="0"
              :max="max"
              :disabled="disableInput"
              v-model="refundAmt"
              placeholder="Введите сумму"
            ></el-input>
          </div>
        </el-col>
        <el-col :span="12" class="total_order_sum">
          <span class="modal_refand_item_title"
            >{{ $t("field_total_amt") }}:</span
          >
          <p class="modal_refand_item_sum">{{ payment.amt }}</p>
        </el-col>
      </el-row>
      <el-row class="aligner">
        <el-button round plain type="danger" @click="save">{{
          $t("do_refund")
        }}</el-button>
      </el-row>
    </section>
    <span slot="title">
      <h4>{{ $t("refund") }}</h4>
    </span>
  </el-dialog>
</template>

<script>
import apiRes from '../../core/apiRes'

export default {
  name: 'invoice-refund-modal',
  props: ['visible', 'callback', 'payment', 'url', 'max'],
  data: () => ({
    radio: '1',
    loading: false,
    amt: 0
  }),
  methods: {
    save () {
      this.loading = true
      apiRes.post(this.url, {
        tid: this.payment.id,
        refund_amount: this.refundAmt,
        a1: 'Возврат'
      }).then((res) => {
        if (this.callback) {
          this.callback()
        }
        this.loading = false
        this.visibleInner = false
      }).catch(() => {
        this.loading = false
      })
    }
  },
  computed: {
    disableInput () {
      return this.radio === '1'
    },
    refundAmt: {
      get () {
        var amt = this.amt < 0 ? 0 : this.amt
        return this.disableInput || parseInt(amt) > parseInt(this.max) ? this.max : amt
      },
      set (val) {
        val = val < 0 ? 0 : val
        this.amt = this.disableInput || parseInt(val) > parseInt(this.max) ? this.max : val
      }
    },
    visibleInner: {
      get () {
        return this.visible
      },
      set (val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    }
  }
}
</script>

<style>
.el-dialog.webpay.refund h4 {
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: left;
  color: #c1c1c1;
  padding: 0;
}

.el-dialog.webpay.refund .card_brand {
  height: 60px;
  width: 120px;
}

.el-dialog.webpay.refund {
  max-width: 532px;
}

.modal_refand_item_title {
  display: inline-block;
  font-family: "Roboto";
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #c1c1c1;
}

.modal_refand_item_subtitle {
  font-family: "Roboto";
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: left;
  color: #606266;
  display: block;
}

.modal_refand_item_sum {
  font-family: "Roboto";
  font-size: 24px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #00abec;
  margin: 0;
}

.total_order_sum {
  text-align: right;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .modal_refand_item_title {
    display: block;
  }
}

@media only screen and (max-device-width: 568px) {
  .modal_refand_item_title {
    display: block;
  }
}

@media only screen and (max-device-width: 640px) {
  .modal_refand_item_title {
    display: block;
  }
}

@media only screen and (max-device-width: 667px) {
  .modal_refand_item_title {
    display: block;
    padding-top: 15px;
  }

  .radio-block,
  .total_order_sum {
    margin-top: 15px;
  }
  .input_total_sum {
    position: relative;
    width: 260px;
    height: 50px;
    margin-top: 15px;
  }
}

@media only screen and (max-device-width: 736px) {
  .modal_refand_item_title {
    display: block;
  }
  .modal_refand_item_title {
    display: block;
    padding-top: 15px;
  }
  .radio-block,
  .total_order_sum {
    margin-top: 15px;
  }
  .input_total_sum {
    position: relative;
    width: 260px;
    height: 50px;
    margin-top: 15px;
  }
}

@media only screen and (max-device-width: 823px) {
  .modal_refand_item_title {
    display: block;
    padding-top: 15px;
  }
  .radio-block,
  .total_order_sum {
    margin-top: 15px;
  }
  .input_total_sum {
    position: relative;
    width: 260px;
    height: 50px;
    margin-top: 15px;
  }
}
</style>
